module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"placeholder":"DD/MM/AAAA"},"en-US":{"placeholder":"MM/DD/YYYY"}}')
  delete Component.options._Ctor
}
